import Icon from '../../components/Icon.vue'

Icon.register({
  'brands/bitcoin': {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M504 256C504 393 393 504 256 504S8 393 8 256 119 8 256 8 504 119 504 256zM362.3 220.7C367.3 187.7 342.2 169.9 307.8 158.1L318.9 113.4 291.7 106.6 280.9 150.1C273.7 148.4 266.4 146.7 259.1 145L270 101.2 242.8 94.4 231.7 139.1C225.7 137.8 219.9 136.4 214.3 135L214.3 134.9 176.8 125.5 169.5 154.6S189.7 159.2 189.3 159.5C200.3 162.2 202.3 169.5 202 175.3L189.3 226.2C190 226.4 191 226.7 192.1 227.1 191.2 226.9 190.2 226.7 189.2 226.4L171.4 297.8C170.1 301.1 166.7 306.1 159 304.2 159.2 304.6 139.2 299.3 139.2 299.3L125.7 330.4 161.1 339.3C167.7 340.9 174.1 342.6 180.5 344.3L169.2 389.5 196.4 396.3 207.6 351.5A1038.2-1038.2 0 0 1 229.3 357.2L218.1 401.7 245.4 408.5 256.6 363.3C303 372.1 337.9 368.6 352.6 326.6 364.4 292.8 352 273.3 327.6 260.6 345.4 256.5 358.8 244.8 362.3 220.7zM300.2 307.8C291.8 341.6 234.9 323.4 216.4 318.8L231.4 258.9C249.8 263.5 309 272.6 300.2 307.8zM308.6 220.2C300.9 250.9 253.6 235.3 238.2 231.5L251.7 177.1C267.1 181 316.6 188.1 308.6 220.2z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/brands/bitcoin.js
// module id = 8AYN
// module chunks = 144